import { InputAdornment } from '@mui/material';
import { Box } from '@mui/system';
import { RichTextInput } from 'ra-input-rich-text';
import * as React from 'react';
import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  ImageInput,
  BooleanInput,
  NumberInput,
  DateInput,
  DateTimeInput,
  ImageField,
  useTranslate,
} from 'react-admin';

export default function ResourceCreate(props: any) {
  const t = useTranslate();
  return (
    <Box sx={styles.boxStyle}>
      <Create sx={styles.createStyle} {...props}>
        <SimpleForm style={styles.inputStyle}>
          <TextInput source='name' sx={styles.inputStyle} />

          <ReferenceInput source='countryId' reference='country'>
            <SelectInput optionText='name' sx={styles.inputStyle} />
          </ReferenceInput>

          <NumberInput
            source='price'
            sx={styles.inputStyle}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('sek')}</InputAdornment>
              ),
            }}
          />
          <NumberInput
            source='minWeight'
            sx={styles.inputStyle}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('g')}</InputAdornment>
              ),
            }}
          />
          <NumberInput
            source='maxWeight'
            sx={styles.inputStyle}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('g')}</InputAdornment>
              ),
            }}
          />
          <NumberInput
            source='fromOrderPrice'
            sx={styles.inputStyle}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('sek')}</InputAdornment>
              ),
            }}
          />
          <NumberInput
            source='toOrderPrice'
            sx={styles.inputStyle}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('sek')}</InputAdornment>
              ),
            }}
          />
          <BooleanInput source='isActive' sx={styles.inputStyle} />
          <BooleanInput source='isDefault' sx={styles.inputStyle} />
        </SimpleForm>
      </Create>
    </Box>
  );
}

const styles = {
  boxStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  createStyle: {
    width: '50%',
    minWidth: 250,
  },
  inputStyle: {
    width: '100%',
  },
};
